const key = "fake-number-response";

const applicable = (resp) => resp.config.url.endsWith("/numbers");

const modify = (resp) => {
	if(resp.status !== 404) {
		throw resp;
	}

	resp.status = 200;
	resp.data.Success = true;
	delete resp.data.Errors;
	delete resp.data.Informations;
	resp.data.Data = {
		Number: 4,
		etag: "abc123"
	};

	return resp;
};

export const fakeNumberResponse = [key, applicable, modify];